import { useMemo } from 'react'
import { useLayerDataFetcher } from '@app/components/Molecules/RiskSideDrawerContent/data_fetchers/layerDataFetcher'
import { useFetchLiveLayers } from '@app/modules/Live/hooks/useFetchLiveLayers'
import { DialogData, HazardScenario, LayerMetadataRecord, LayerPlusScenarios } from '@app/types'
import { isContextualLayer, isElementLayer } from '../workspace.utils'

// Full layer metadata available to a workspace, used to hydrate stripped-down layer ids
export const useWorkspaceLayerOptions = () => {
  const layersData = useLayerDataFetcher() as DialogData
  const { data: liveFeeds, isLoading: isLoadingLiveLayers } = useFetchLiveLayers()

  const hazardLayers: LayerPlusScenarios[] = useMemo(() => {
    if (!layersData?.layers) return []
    const hLayers = layersData.layers.filter((layer: LayerMetadataRecord) =>
      layer.id.startsWith('h'),
    )
    return hLayers.map((layer) => {
      const categories = layer.categories?.map((category) => category.display_name)
      const scenarios: HazardScenario[] = []

      layersData.hazardDialogData.hazardDetails.map((detail) => {
        if (categories?.includes(detail.title)) {
          detail.scenarios.map((scenario) => {
            if (`h${scenario.hazard_id}` === layer.id) {
              scenarios.push(scenario)
            }
          })
        }
      })

      return { ...layer, scenarios }
    })
  }, [layersData])

  const elementLayers: LayerMetadataRecord[] = useMemo(() => {
    if (!layersData?.layers) return []
    return [
      ...new Map(
        layersData.layers.filter(isElementLayer).map((layer) => [layer.id, layer]),
      ).values(),
    ]
  }, [layersData])

  const contextualLayers: LayerMetadataRecord[] = useMemo(() => {
    if (!layersData?.layers) return []
    return layersData.layers.filter(isContextualLayer)
  }, [layersData])

  const liveLayers: LayerMetadataRecord[] = useMemo(() => {
    if (!liveFeeds?.data) return []
    return liveFeeds.data.map((feed) => ({
      id: feed.id,
      type: feed.type,
      title: feed.title,
      metadata: null,
      suitability: [],
    }))
  }, [liveFeeds])

  return { hazardLayers, elementLayers, contextualLayers, liveLayers, isLoadingLiveLayers }
}
